import {
  Badge,
  Button,
  Menu,
  MenuContent,
  MenuTrigger,
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableHeaderCell,
  TableRow,
  Text,
} from '@optiaxiom/react';
import { IconEllipsisSolid } from '@optimizely/axiom-icons';

import type { RAGConfiguration } from '../types';

type RAGConfigurationTableProps = {
  configurations: RAGConfiguration[];
  isLoadingConfigurations: boolean;
  onToggleStatus: (turnstileId: string) => void;
};

function RAGConfigurationTable({
  configurations,
  isLoadingConfigurations,
  onToggleStatus,
}: RAGConfigurationTableProps) {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHeaderCell>Product</TableHeaderCell>
          <TableHeaderCell>Instance ID</TableHeaderCell>
          <TableHeaderCell>Status</TableHeaderCell>
          <TableHeaderCell>Database</TableHeaderCell>
          <TableHeaderCell>Organization</TableHeaderCell>
          <TableHeaderCell pinned />
        </TableRow>
      </TableHeader>
      <TableBody>
        {isLoadingConfigurations ? (
          <TableRow>
            <TableCell colSpan={6}>
              <Text fontSize="sm" color="fg.secondary">
                Loading configurations...
              </Text>
            </TableCell>
          </TableRow>
        ) : configurations.length === 0 ? (
          <TableRow>
            <TableCell colSpan={6}>
              <Text fontSize="sm" color="fg.secondary">
                No configurations found
              </Text>
            </TableCell>
          </TableRow>
        ) : (
          configurations.map((config: RAGConfiguration) => (
            <TableRow key={config.turnstile_id}>
              <TableCell>
                <Badge variant="subtle" intent="information">
                  {config.product}
                </Badge>
              </TableCell>
              <TableCell>
                <Text fontSize="md" fontWeight="500">
                  {config.opal_instance_id}
                </Text>
              </TableCell>
              <TableCell>
                <Badge variant="subtle" intent={!config.deactivated ? 'success' : 'neutral'}>
                  {!config.deactivated ? 'Active' : 'Inactive'}
                </Badge>
              </TableCell>
              <TableCell>
                <Text fontSize="sm" color="fg.secondary">
                  {config.spanner_db_name}
                </Text>
              </TableCell>
              <TableCell>
                <Text fontSize="sm" color="fg.secondary">
                  {config.cmp_org_id}
                </Text>
              </TableCell>
              <TableCell>
                <Menu
                  options={[
                    {
                      label: !config.deactivated ? 'Deactivate' : 'Activate',
                      intent: 'neutral',
                      execute: () => onToggleStatus(config.turnstile_id),
                    },
                  ]}
                >
                  <MenuTrigger asChild>
                    <Button appearance="subtle" icon={<IconEllipsisSolid size="16" />} />
                  </MenuTrigger>
                  <MenuContent />
                </Menu>
              </TableCell>
            </TableRow>
          ))
        )}
      </TableBody>
    </Table>
  );
}

export default RAGConfigurationTable;
